<template>
  <v-dialog v-model="visible" persistent max-width="839">
    <v-card class="v-dialog--custom v-dialog--custom-import" v-if="visible">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">
          <Label
            v-if="unresolvedConflicts.length"
            :value="unresolvedConflicts.length"
            :colored="Boolean(unresolvedConflicts.length)"
            warning
            icon
          />

          <Label
            v-if="resolvedConflicts.length"
            class="ml-2"
            :value="resolvedConflicts.length"
            colored
            success
            icon
          />

          <span class="ml-3">{{ $t(`${namespace}.title`) }}</span>
        </span>

        <v-btn
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          @click="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-if="!selectedItems.length" class="px-4 pt-0">
        <p v-html="$t(`${namespace}.text`)" class="ma-0 pa-0" />
      </v-card-text>

      <Actions
        :selectedItems="selectedItems.length"
        :conflicts="unresolvedConflicts.length"
        :solvedConflicts="resolvedConflicts.length"
        @handleConflictAction="handleConflictAction"
      />

      <div class="table">
        <v-layout
          align-center
          class="grey--text text--darken-4 px-3 caption grey lighten-4 has-border-b table-header"
        >
          <v-flex class="table__checkbox" xs1>
            <v-checkbox
              v-model="checkedAllItems"
              color="accent-2"
              hide-details
              @change="handleCheckedAllItems"
            />
          </v-flex>
          <v-flex xs3>{{ $t(`${namespace}.registeredName`) }}</v-flex>
          <v-flex xs3>{{ $t(`${namespace}.updatedName`) }}</v-flex>
          <v-flex xs2>{{ $t(`${namespace}.contact`) }}</v-flex>
          <v-flex xs3>{{ $t(`${namespace}.email`) }}</v-flex>
        </v-layout>

        <v-list v-if="unresolvedConflicts.length" subheader two-line class="table__body">
          <div v-for="(line, i) in unresolvedConflicts" :key="i">
            <v-list-tile
              class="list__item"
              :class="{ 'table__body__tr--active': activateLine(line) }"
            >
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <v-layout align-center class="grey--text text--darken-4 px-3">
                    <v-flex class="table__checkbox" xs1>
                      <v-checkbox
                        v-model="selectedItems"
                        color="accent-2"
                        :value="line.conflicts[0].id"
                        hide-details
                        @change="handleSelectedItems"
                      />
                    </v-flex>
                    <v-flex xs3>
                      <div class="line__arrow">
                        <span class="text--ellipsis" title="">
                          {{ line.conflicts[0].name }}
                        </span>
                        <v-icon>keyboard_arrow_right</v-icon>
                      </div>
                    </v-flex>
                    <v-flex xs3>
                      <span class="text--ellipsis" title="">
                        {{ line.name }}
                      </span>
                    </v-flex>
                    <v-flex xs2>
                      <span class="text--ellipsis" title="">
                        {{ line.conflicts[0].phone | phoneWithDDD }}
                      </span>
                    </v-flex>
                    <v-flex xs3>
                      <span class="text--ellipsis" title="">
                        {{ line.conflicts[0].email }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider v-if="i < unresolvedConflicts.length" />
          </div>
        </v-list>

        <div class="no-conflicts" v-else>
          <span v-html="$t(`${namespace}.noConflicts`)" />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { isArray } from 'utils/functions'
import Label from 'components/bulkImport/Label'
import Actions from './Actions'

export default {
  name: 'DialogSolvedConflicts',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    solvedConflictsNumber: {
      type: Number,
      default: 0
    }
  },
  components: {
    Label,
    Actions
  },
  computed: {
    unresolvedConflicts () {
      return this.conflicts.filter(conflict => !conflict.status)
    },

    resolvedConflicts () {
      return this.conflicts.filter(conflict => conflict.status)
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.status.dialogSolvedConflicts',
      selectedItem: null,
      checkedAllItems: false,
      selectedItems: [],
      conflicts: []
    }
  },
  methods: {
    close () {
      this.$emit('close')
      // this.$emit('updatePayload', {
      //   ...this.data,
      //   data: [...this.conflicts]
      // })

      // this.data. = {
      //   ...this.data,
      //   data: [...this.conflicts]
      // }

      if (this.conflicts.length) {
        this.data.data = [...this.conflicts]
      }
    },

    resetAttributes () {
      this.selectedItem = null
      this.checkedAllItems = false
      this.selectedItems = []
    },

    isValidArray (val) {
      return isArray(val)
    },

    activateLine (item) {
      return item.conflicts[0].id === this.selectedItem || this.selectedItems.find(i => i === item.conflicts[0].id)
    },

    handleCheckedAllItems (val) {
      this.selectedItems = val
        ? [...this.unresolvedConflicts].map(item => item.conflicts[0].id)
        : []
    },

    handleSelectedItems (val) {
      this.checkedAllItems = this.selectedItems.length === this.unresolvedConflicts.length
    },

    renderConflicts () {
      this.conflicts = [...this.data.data]
    },

    undoResolvedConflicts () {
      this.conflicts = this.conflicts.map(conflict => {
        delete conflict.status
        return conflict
      })
    },

    isSelectedItem (conflictId) {
      return this.selectedItems.find(id => id === conflictId)
    },

    resolveConflicts (action) {
      this.conflicts = this.conflicts.map(conflict => {
        const conflictId = this.isValidArray(conflict.conflicts) ? conflict.conflicts[0].id : 0
        const conflictName = this.isValidArray(conflict.conflicts) ? conflict.conflicts[0].name : ''
        const register = action === 'update'
          ? { id: conflictId, name: conflictName }
          : null

        if (this.isSelectedItem(conflictId)) {
          conflict.status = { code: action, register }
          this.solvedConflicts++
        }

        return conflict
      })
    },

    handleConflictAction (action) {
      if (action === 'undo') {
        this.undoResolvedConflicts()
        this.resetAttributes()
        return
      }

      this.resolveConflicts(action)
      this.resetAttributes()
    }
  },
  watch: {
    conflicts (val) {
      if (!val.length && this.visible) this.resetAttributes()
    },

    visible (val) {
      if (!val) {
        return this.resetAttributes()
      }

      this.renderConflicts()
    },

    resolvedConflicts (val = []) {
      this.$emit('resolvedConflicts', val.length)
    }
  }
}
</script>

<style lang="scss">
.v-dialog--custom-import {

  .v-dialog--custom__title {
    align-items: center;
    display: flex;
  }

  .table__header,
  .table__body {
    max-width: 100%;
    min-width: 100%;
  }

  .table-hover .table-body .v-list__tile {
    cursor: default;
  }

  .v-list__tile {
    padding-left: 0;
    padding-right: 0;
  }

  .v-list__tile__title, .v-list__tile__sub-title {
    overflow: initial;
  }
}
</style>

<style lang="scss" scoped>
.table-body {
  max-height: calc((72px + 1px) * 5);
  overflow: auto;
}

.table__checkbox {
  max-width: 40px;
}

.text--ellipsis {
  font-size: 12px;
}

.line__arrow {
  align-items: center;
  display: flex;

  .v-icon {
    margin-left: auto;
  }
}

.no-conflicts {
  align-items: center;
  background-color: #f6f6f6;
  display: flex;
  justify-content: center;
  min-height: calc((72px + 1px) * 3);
}
</style>
